export var CONNECT_EVENT = "connect";
export var ERROR_EVENT = "error";
export var CLOSE_EVENT = "close";
export var SELECT_EVENT = "select";
export var EXTENSION_AUTH_EVENT = "extension-auth";
export var EXTENSION_WINDOW_CLOSED_EVENT = "extension-window-closed";
